import { tryParseInt } from '@witkac/utils/tryParseInt';
import { PublicSettings } from '@witkac/kartamiejska-shared';
import { RouteConfig } from 'vue-router';

import store from '@/store';

export const partnerDetailsRoute: RouteConfig = {
  path: ':id',
  component: () => import(/* webpackChunkName: "PartnerDetails" */ '@/views/main/partner/Details.vue'),
  name: 'partnerDetails',
  meta: {
    nested: true
  },
  beforeEnter(to, _from, next) {
    Promise.all([
      store.dispatch('partner/get', tryParseInt(to.params.id)),
      store.dispatch('place/list', { partnerId: tryParseInt(to.params.id) }),
      store.dispatch('benefit/list', {
        partnerId: tryParseInt(to.params.id)
      }),
      store.dispatch('settings/get', PublicSettings.CARD_STATE_COLOR)
    ]).then(() => next());
  }
};
